export default {
    data: () => ({
        translations: {
            newAction: {
                el: "Προσθήκη Ενέργειας",
                en: "New Action",
                it: "Nuova azione"
            },
            updateAction: {
                el: "",
                en: "Update Action",
                it: ""
            },
            giftCategory: {
                el: "Κατηγορία Δώρου",
                en: "Gift Category",
                it: "Categoria di regalo"
            },
            info: {
                el: "Για να δημιουργήσεις κουπόνι '1+1 Δώρο' θα πρέπει να δηλώσεις ένα προϊόν για αγορά και ένα προϊόν για δώρο. Όρισε τα προϊόντα στην παρακάτω λίστα.",
                en: `
                    To create a 1+1 coupon promotion you must select one product for purchase and 
                    one to give away as a reward. Select these products from the list below.
                `,
                it: "Per creare un coupon '1 + 1 Gift' devi dichiarare un prodotto da acquistare e un prodotto da regalare. Definire i prodotti nell'elenco sottostante."
            },
            productForSale: {
                el: "Προϊόν για αγορά",
                en: "Purchase Product",
                it: "Prodotto per l'acquisto"
            },
            productForGift: {
                el: "Προϊόν για δώρο",
                en: "Giveaway Product",
                it: "Prodotto per regalo"
            },
            totalCoupons: {
                el: "Σύνολο Κουπονιών",
                en: "Total Coupons",
                it: "Totale Coupon"
            }
        }
    })
};
